export default class BasketLine
{
    /** @type {?number} */
    id = null;

    /** @type {number} */
    quantity = null;

    /** @type {?string} */
    article_code = null;

    /** @type {Record<string, any>} */
    article_data = {};

    /** @type {Record<string, any>} */
    logistics_data = {};

    /** @type {Record<string, any>} */
    return_data = {};

    /** @type {?number} */
    dependency_code = null;

    /** @type {?string} */
    order_by = null;

    /** @type {?string} */
    delivery_to = null;

    /** @type {Array<{quantity: number, article_code: string}>} */
    supplements = [];

    /** @type {Record<string, any>} */
    extra = {};

    /** @type {?number} */
    special_price = null;

    /** @type {?boolean} */
    special_price_is_computed = null;

    /** @type {?string} */
    ecom = null;

    /** @type {?string} */
    fitting_session_id = null;

    /** @type {?number} */
    previous_order_reference = null;

    /** @type {?string} */
    created_at = null;

    /** @type {?string} */
    updated_at = null;


    // ------------------------------------------------------------ CONSTRUCTOR

    constructor(attributes = {})
    {
        if(attributes)
        {
            this.setAttributes(attributes);
        }
    }


    // ------------------------------------------------------------ ATTRIBUTES

    setAttributes(attributes)
    {
        for(const key in attributes)
        {
            if(this[key] !== undefined)
            {
                this[key] = attributes[key];
            }
        }
    }


    // ------------------------------------------------------------ SETTERS

    setArticleDataAttribute(key, val)
    {
        this.article_data[key] = val;
    }

    setArticleDataAttributeDefaultValue(key, defaultVal)
    {
        if(!this.article_data.defaults)
        {
            this.article_data.defaults = {};
        }

        this.article_data.defaults[key] = defaultVal;
    }

    setLogisticsDataAttribute(key, val)
    {
        this.logistics_data[key] = val;
    }

    setReturnDataAttribute(key, val)
    {
        this.return_data[key] = val;
    }

    setExtraAttribute(key, val)
    {
        this.extra[key] = val;
    }


    // ------------------------------------------------------------ GETTERS

    getArticleDataAttribute(key)
    {
        return this.article_data[key];
    }

    getLogisticsDataAttribute(key)
    {
        return this.logistics_data[key];
    }

    getReturnDataAttribute(key)
    {
        return this.return_data[key];
    }

    getExtraAttribute(key)
    {
        return this.extra[key];
    }
}
